import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NativeShellService } from '@core/services/native-shell/native-shell.service';

export const nativeTrackingGuard: CanActivateFn = async () => {
  const shell = inject(NativeShellService);
  const router = inject(Router);
  try {
    return (
      (await shell.initialize())?.tracking === true ||
      router.parseUrl('/forbidden')
    );
  } catch {
    return router.parseUrl('/access-unavailable');
  }
};
